import TabModulesTemplate from "components/Modules/TabModulesTemplate"
import React from "react"
import WebsiteBlogForm from "./_tabs/WebsiteBlogForm"
import WebsiteBlogTable from "./_tabs/WebsiteBlogTable"

const WebsiteBlog = () => {
  return (
    <div className="page-content">
      <TabModulesTemplate
        documentTabs={[
          {
            label: "Form",
            Component: opened => <WebsiteBlogForm opened={opened} />,
          },
        ]}
        collectionTabs={[
          {
            label: "Table",
            Component: () => <WebsiteBlogTable />,
          },
        ]}
      />
    </div>
  )
}

export default WebsiteBlog
